import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { momentUpdateLocale } from 'helpers/date';
import { lsGetSettingByName, lsSetSettingByName } from 'helpers/local-storage';

Vue.use(VueI18n);

const locale = lsGetSettingByName('locale') || document.querySelector('html').getAttribute('lang');
const loadedLanguages = [locale]; // our default language that is prelaoded

let i18nMutable = null;
export const i18nLoadLanguage = () =>
  import(/* webpackChunkName: "lang-[request]" */ `@/locale/${locale}`).then(msgs => {
    i18nMutable = new VueI18n({
      locale, // set locale
      fallbackLocale: locale,
      messages: { [locale]: msgs.default }
    });
    // Init moment.js language
    momentUpdateLocale(locale, msgs.default.moment.config);
    return i18nMutable;
  });

export const i18n = () => i18nMutable;

const setI18nLanguage = lang => {
  // i18n().locale = lang;
  lsSetSettingByName('locale', lang);
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
};

export const loadLanguageAsync = lang => {
  if (i18n().locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/locale/${lang}`).then(msgs => {
        i18n().setLocaleMessage(lang, msgs.default);
        loadedLanguages.push(lang);
        return setI18nLanguage(lang);
      });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
};
